import React, { useMemo, useCallback } from "../../../__compat__/react/main.entry.mjs.mjs";
import { eachMonthOfInterval, startOfYear, endOfYear, getMonth, getYear, subYears, addYears, } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
import { range } from "../../../__compat__/lodash/main.entry.mjs.mjs";
import { useLocale } from "../../LocaleProvider/index.mjs.mjs";
import { pickAriaProps, pickComponentCommonProps, } from "../../../interfaces/commonProps.mjs.mjs";
import { useSpacing } from "../../../api/spacing/useSpacing.mjs.mjs";
import { BarrelSelect, BarrelSelectGroup } from "./BarrelSelect/index.mjs.mjs";
export const YearSelect = ({ minDate = subYears(new Date(), 100), maxDate = addYears(new Date(), 100), value, onChange = () => { }, ...restProps }) => {
    const { datePicker: locale, localeIdentifier } = useLocale();
    const commonProps = pickComponentCommonProps(restProps);
    const ariaProps = pickAriaProps(restProps);
    const spacing = useSpacing(restProps);
    const formatter = useMemo(() => new Intl.DateTimeFormat(locale.dateLocale || localeIdentifier, {
        month: 'long',
        year: 'numeric',
    }), [localeIdentifier, locale.dateLocale]);
    const segments = formatter
        .formatToParts(value)
        .filter((entry) => ['month', 'year'].includes(entry.type));
    const yearValue = getYear(value);
    const monthValue = getMonth(value);
    const months = useMemo(() => eachMonthOfInterval({
        start: startOfYear(new Date()),
        end: endOfYear(new Date()),
    }).map((date) => {
        var _a;
        return ({
            label: ((_a = formatter.formatToParts(date).find((entry) => entry.type === 'month')) === null || _a === void 0 ? void 0 : _a.value) || '',
            value: date.getMonth(),
        });
    }), [formatter]);
    const years = useMemo(() => range(minDate.getFullYear(), maxDate.getFullYear()).map((year) => ({
        label: year.toString(),
        value: year,
    })), [minDate, maxDate]);
    const handleMonthChange = useCallback((month) => {
        onChange(new Date(yearValue, month));
    }, [onChange, yearValue]);
    const handleYearChange = useCallback((year) => {
        onChange(new Date(year, monthValue));
    }, [monthValue, onChange]);
    const barrelProps = {
        year: {
            onChange: handleYearChange,
            value: yearValue,
            options: years,
            'aria-label': locale.yearSelectorLabel,
            'aria-valuemin': years[0].value,
            'aria-valuemax': years[years.length - 1].value,
        },
        month: {
            onChange: handleMonthChange,
            value: monthValue,
            options: months,
            'aria-label': locale.monthSelectorLabel,
            'aria-valuemin': months[0].value,
            'aria-valuemax': months[months.length - 1].value,
        },
    };
    return (React.createElement(BarrelSelectGroup, { ...commonProps, ...ariaProps, spacing: spacing }, segments.map((segment) => (React.createElement(BarrelSelect, { id: `${restProps.id}_year-select_${segment.type}`, key: segment.type, ...barrelProps[segment.type] })))));
};
//# sourceMappingURL=YearSelect.mjs.mjs.map